// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RichTextEditor_wrapper__3NM9f","editor":"RichTextEditor_editor__3TiVA","toolbar":"RichTextEditor_toolbar__1oJMF"};